import PullToRefreshLib from "../libs/pullToRefresh";
import gsap from "gsap";
import {Swiper, EffectCube} from "swiper";

import { a11yUnconfirmed } from './simple.ui';


// /**
//  * 현재 viewport에 요소가 있는지 없는지 검사하는 유틸
//  * @param element   체크해야할 요소
//  * @param target    해당 viewport
//  * @returns {boolean}   포함되어있다면 true
//  */
export function isInViewport(element, target){
    if (!$(element).is(':visible')) return false;

    const rect = element.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    return rect.top <= targetRect.height
}

// /**
//  * 메인 타임라인에서 상단으로 당기면 callback을 발생하는 유틸
//  * @type {{init: init, destroy: destroy}}
//  */
 export const mainTimelinePullToRefresh = (function mainTimelinePullToRefresh(){
    function init(callback){
        PullToRefreshLib.init({
            mainElement: '#pull-down-content',
            onRefresh(done){
                callback(done);
            },
            shouldPullToRefresh(){
                return (function(){
                    return !$('#content_3').scrollTop();
                })();
            }
        });
    }

    function destroy(){
        PullToRefreshLib.destroyAll();
    } 

    return {
        init,
        destroy
    };
})();

// /**
//  * 메인 하단 4개의 탭을 컨트롤하는 함수
//  * @example
//  *  $('.home-tab-menu').data('ui').goToTab(id|index);
//  */
function mainTabControl(){
    const $mainTabGroup = $('.main-tab-container > div');
    const $homeTabMenu = $('.home-tab-menu');

    //llog('     start:: main mainTabControl')

    if(!$homeTabMenu[0] || $homeTabMenu.data('mainTabControl')){
        console.log('여기')
        return;
    }
    //llog('init:: mainTabControl')
    $homeTabMenu.data('mainTabControl', true)

    $homeTabMenu.data('ui', {
        goToTab: (idOrIndex) => {
            if(typeof idOrIndex === 'number'){
                return $homeTabMenu.find('.btn-group > a').eq(idOrIndex).trigger('click');
            }

            return $homeTabMenu.find('.btn-group > a').filter(`#${idOrIndex}`).trigger('click');
        },
    });
    $homeTabMenu.on('click openTab', '.btn-group > a', function(e){
        e.preventDefault();
        /*
        const index = $(this).index();

        $(this).addClass('on').siblings().removeClass('on');
        gsap.killTweensOf($('.main-tab-container > div'));
        const tm = gsap.timeline();

        $('.main-tab-container > div').eq(index).show();
        $('.main-tab-container > div').eq(index).siblings().hide();
        */
        // s: FETASK-391
        const index = $(this).index();
        const $tabMenu = $('.main-tab-container > div');

        if($('body').hasClass('a11y')){
            setTimeout(() => {
                if(index === 0){
                    //홈
                    $('.btn-logo-kbank')
                    .focus();
                }else if(index === 1 || index === 2 || index === 3){
                    //상품
                    $(`#content_${index+1}`)
                    .find('.home-tit')
                    .attr({'aria-hidden':'false','tabindex':'-1'})
                    .focus();
                }
            },1200);
        }

        if ($(this).hasClass('on')) {
            // 활성화된 탭 클릭시 최상단으로 스크롤만 진행
            $tabMenu.eq(index)[0].scrollTo({top: 0, behavior: 'smooth'});
            return false;
        }

        $(this).addClass('on').siblings().removeClass('on');
        gsap.killTweensOf($tabMenu);
        const tm = gsap.timeline();

        $tabMenu.eq(index).show().siblings().hide();

        if (index === 0) {
            if ($('.flip-conts.ui-swiper').length> 0) {
                console.log('홈탭 click $flip-conts swiper')
                $('.flip-conts.ui-swiper').data('ui').update();
            }
        }

        if (index === 1) {
            if ($(window).scrollTop() == 0 && $('.main-tab-content02 .product-recommend').attr('offsettop') == undefined) {

                frontUI.main.mainFixedTab()
            }
        }
        // 221226: 타임라인은 활성화되면 항상 최상단으로 스크롤
        if (index === 2) {
            $tabMenu.eq(index)[0].scrollTo(0, 0);
        }
        // e: FETASK-391


        // 221209 메인 노치 색상 이슈
        // const contBg = $('.main-tab-container > div').eq(index).find('.container-component').css('background-color');
        // let rule;
        // if (index === 0 ) {
        //     let css = document.createElement('style');
        //     css.type = 'text/css';
        //     css.classList.add('notchBg')
        //     rule = 'body {background:-moz-linear-gradient(#f8f8f8, #fff);background:-o-linear-gradient(#f8f8f8, #fff);background:-webkit-linear-gradient(#f8f8f8, #fff); background:linear-gradient(#f8f8f8, #fff)}'

        //     css.appendChild(document.createTextNode(rule));
        //     document.getElementsByTagName('head')[0].appendChild(css)

        //     $('.main-tab-container > div').eq(index).css('background-color',contBg)
        // } else {
        //     $('.notchBg').remove();
        //     $('.main-tab-container > div').eq(index).css('background-color', '')
        // }

        setTimeout(() => {
            if(index !== 0) mainRevealAnimationInit(index);
            if(index === 1) frontUI.tabMenuExtend(); // SR-1962 추천탭 1.3 : 탭스크롤 기능 추가 update 2022-10-11
        })

        // SR-2014 homebar 아이콘 :  아이콘 애니메이션 lottie 추가
        if ($homeTabMenu.hasClass('new-home')) {
            $homeTabMenu.find('.btn-group > a .icon-lottie').remove();
            $(this).find('.btn-ico-item').append('<i class="btn-home-icon icon-lottie" aria-hidden="true" id="lottieHomeTab"></i>');
            frontUI.lottieAnimation('lottieHomeTab','/resource/js/mmk/json/homebar/'+$(this).attr('id')+'.json',false, '1.5')
        }


    })
    if ($homeTabMenu.hasClass('new-home')) {
        $homeTabMenu.find('.btn-group > a .icon-lottie').remove();
        $homeTabMenu.find('.btn-group > a.on .btn-ico-item').append('<i class="btn-home-icon icon-lottie" aria-hidden="true" id="lottieHomeTab"></i>');
        frontUI.lottieAnimation('lottieHomeTab','/resource/js/mmk/json/homebar/home-tab1.json',false, '1.5')
    }

    const selectedTabID = $homeTabMenu.find('.btn-group .on').attr('id');

    if($homeTabMenu[0]) $homeTabMenu.data('ui').goToTab(selectedTabID)
    const arrScrollEl = $('.main-tab-content01, .main-tab-content02, .main-tab-content03, .main-tab-content04').toArray();
    arrScrollEl.forEach((scrollEl) => {
        scrollEl.addEventListener('scroll', (e) => {
            const _this = e.target;

            if(_this.scrollTop > 0){
                _this.classList.add('scrolling')
            }else{
                _this.classList.remove('scrolling')
            }
        }, {passive: true})
    })
}

// /**
//  * 추천탭의 카드의 최상단 마진제거를 위하여 css로 안되는 기능이라 스크립트로 실행함
//  */
export function mainBenefitSpaceMargin(){
    var returnValue = "mainBenefitSpaceMargin";
    $('.main-tab-content02 ' +
        '.container-component >div' +
        ':not(.component-header)' +
        ':not(.component-tab)')
        .removeClass('benefit-list-space')
        .filter(':visible:eq(0)')
        .addClass('benefit-list-space')
    return returnValue;
}

export function mainFixedTab(){
    if ($('.main-tab-content02 .product-recommend').length > 0 && $('.main-tab-content02').is(":visible")) {
        // if ($('.main-tab-content02 .product-recommend').find('.clone').length == 0) {
        //     var clone = $('.main-tab-content02 .headertab-products').clone(true)
        //     clone.addClass('clone')
        //     $('.main-tab-content02 .product-recommend').before().prepend(clone)
        // }


        let prodRcmm,prodRcmmFixTop,  headertabPrdt, headertabPrdtH,headertabPrdtClone
        prodRcmm = $('.main-tab-content02 .product-recommend');
        prodRcmm.attr('offsetTop', prodRcmm.offset().top)
        prodRcmmFixTop = prodRcmm.attr('offsettop');
        headertabPrdt = $('.main-tab-content02 .headertab-products').not('.clone');
        //headertabPrdtClone = $('.main-tab-content02 .headertab-products.clone');
        headertabPrdtH = headertabPrdt.outerHeight(true);
        //headertabPrdtClone.attr('style','top:'+headertabPrdtH*-1+'px !important')
        if ($('html').hasClass('ios') && headertabPrdt.attr('transition') == undefined) {
            headertabPrdt.css('transition','top 0.08s')
        }
        var topSetting = 0;
        //var chk = false
        $('.main-tab-content02').on('scroll', (e) => {
            const _this = e.target;

            if ($('.main-tab-content02.scrolling .product-recommend').length > 0){
                if (_this.scrollTop > prodRcmmFixTop - headertabPrdtH ) {
                    topSetting = ((_this.scrollTop+headertabPrdtH)-prodRcmmFixTop) * -1;
                    if ((_this.scrollTop+headertabPrdtH)-prodRcmmFixTop < headertabPrdtH && !headertabPrdt.hasClass('hide')) {
                        headertabPrdt.css('top', topSetting + 'px')
                        // headertabPrdtClone.find('.tab-list-col').scrollLeft(headertabPrdt.find('.tab-list-col').scrollLeft())
                        // headertabPrdt.addClass('hide');
                        // headertabPrdtClone.addClass('show');
                        // chk = true;
                    } else {
                        // if (chk) {
                        //     headertabPrdt.find('.tab-list-col').scrollLeft(headertabPrdtClone.find('.tab-list-col').scrollLeft())

                        // }
                        headertabPrdt.css('top', headertabPrdtH *-1 + 'px')
                    }
                } else {
                    headertabPrdt.css('top', 0)
                    //headertabPrdt.removeClass('hide');
                    //headertabPrdtClone.removeClass('show');

                }
                if (_this.scrollTop > prodRcmmFixTop) {
                    //console.log(1111)
                } else {
                    //console.log(2222)
                }
            }
        })
    }
}

// /**
//  * tab4 ui완료 웹컴톡 애니메이션, 개발 미완료(전달은 된상태 이아르미님)
//  */
export function mainTalkWelcome(){
    var returnValue = "mainTalkWelcome";
    setTimeout(() => {
        gsap.set('.btn-chatbot', {autoAlpha: 0, x: 0, scale: 1})
        $('.btn-chatbot').addClass('ing')
        gsap.set('.btn-chatbot', {animation: 'none'})
        gsap.set('.btn-chatbot .chatbot-reply', {autoAlpha: 0})
        const targetWidth = 200//$('.btn-chatbot').width();
        gsap.set('.btn-chatbot', {width: 60})

        const tm = gsap.timeline();
        tm.to('.btn-chatbot', {duration: 0.7, x: 0, scale: 1, autoAlpha: 1, width: targetWidth, ease: 'Back.easeOut'})
        tm.to('.btn-chatbot .ico-chatbot', {duration: 0, display: 'none'}, 0.7)
        tm.to('.btn-chatbot .chatbot-reply', {duration: 0.3, display: 'block', autoAlpha: 1}, 0.35)
        tm.to('.btn-chatbot .chatbot-reply', {duration: 0.3, autoAlpha: 0}, 2.9)
        tm.to('.btn-chatbot', {duration: 0.7, width: 60, ease: 'Back.easeOut', onComplete: () => {
                $('.btn-chatbot, .btn-chatbot .chatbot-reply, .btn-chatbot .ico-chatbot').removeAttr('style')
                $('.btn-chatbot').removeClass('ing')
            }}, 3)
    }, 2000)
    return returnValue;
}

// /**
//  * 메인 타임라인 스크롤 하단 이동시 callback
//  * @param triggerPosition   화면의 하단 몇 퍼센트 남았을 경우 callback 발생
//  * @param callback  callback
//  */
export const mainTimelineMoreView = function(triggerPosition = 30, callback = () => {}){
    let $el, eventHandler;
    var returnValue = "mainTimelineMoreView";
    destroy();
    $el = $('.main-tab-content03');
    const elHeight = $el.height();
    let height = ($el.find('.main-tab-content-inner>.container-component').height() - elHeight) - elHeight / 100 * triggerPosition
    height = height - $('.home-tab-menu').outerHeight();

    eventHandler = (e) => {
        const _this = e.target;
        const st = _this.scrollTop;

        if(_this.scrollTop > height){
            callback && $.isFunction(callback) && callback();

            destroy();
        }
    }

    $el[0].addEventListener('scroll', eventHandler, {passive: true})

    function destroy(){
        if($el && $el[0] && eventHandler){
            $el[0].removeEventListener('scroll', eventHandler);
            // console.log('destroy')
        }
    }
    return returnValue;
};

// /**
//  * 기존 mainTimelineMoreView 현재 사용하지 않음
//  * @deprecated
//  * @param triggerPosition
//  * @param callback
//  */
export function mainTimelineMoreViewPast(triggerPosition = 30, callback = () => {}){
    const $el = $('.main-tab-content03');
    const elHeight = $el.height();
    let height = ($el.find('.main-tab-content-inner>.container-component').height() - elHeight) - elHeight / 100 * triggerPosition
    height = height - $('.home-tab-menu').outerHeight();

    $el.on('scroll.timelineScroll', (e) => {
        const _this = e.target;

        if(_this.scrollTop > height){
            callback && $.isFunction(callback) && callback();
            $el.off('scroll.timelineScroll');
        }
    })
}

let $mainTab01, $mainTab02, $mainTab03, $mainTab01AnimationEls, $mainTab02AnimationEls, $mainTab03AnimationEls, mainTabs, mainTabAnimationEls;

// /**
//  * 메인 나타남 애니메이션과 스크롤 애니메이션 실행
//  * 아래 요소들만 실행
//  */
export function mainRevealAnimationElInit(){
    $mainTab01 = $('.main-tab-content01').get(0);
    $mainTab02 = $('.main-tab-content02').get(0);
    $mainTab03 = $('.main-tab-content03').get(0);

    $mainTab01AnimationEls = $('.main-tab-content01 .container-component > div:not(.component-header):not(.ui-animation):visible');
    $mainTab02AnimationEls = $('.main-tab-content02 .container-component > div:not(.component-header):not(.component-tab):not(.ui-animation)');
    $mainTab03AnimationEls = $(`
        .main-tab-content03 .section-component .component-banner:not(.ui-animation),
        .main-tab-content03 .section-component .component-form-date:not(.ui-animation),
        .main-tab-content03 .section-component .component-card:not(.ui-animation),
        .main-tab-content03 .section-component .component-text:not(.ui-animation),
        .main-tab-content03 .section-component .component-nodata:not(.ui-animation),
        .main-tab-content03 .section-component .card-timeline-group:not(.ui-animation),
        .main-tab-content03 .section-component .btn-group:not(.ui-animation)
    `);

    mainTabs = [
        $mainTab01,
        $mainTab02,
        $mainTab03
    ];

    mainTabAnimationEls = [
        $mainTab01AnimationEls.toArray(),
        $mainTab02AnimationEls.toArray(),
        $mainTab03AnimationEls.toArray()
    ];
}

// /**
//  * 메인 나타남 애니메이션과 스크롤 애니메이션 초기화
//  * @param index 메인 4개의 탭 index
//  * @param reset 애니메이션을 다시 실행함
//  */
export function mainRevealAnimationInit(index, reset = false){
    var returnValue = "mainRevealAnimationInit";
    console.log('mainRevealAnimationI',index)
    setTimeout(() => {
        //console.log('mainRevealAnimationInit')
        //mainRevealAnimationInitImpl(index, reset);


    /*! s: FETASK-a11y page 메인 하단 tab버튼 접근성 v.1.0.0 */
        $(document).ready(() => {
            if($('body').hasClass('a11y')){
                const $homeTabMenu = $('.home-tab-menu');

                if(index === 0){
                    console.log('0',  $homeTabMenu.find('.btn-group a.on'))
                    $homeTabMenu.find('.btn-group a').attr({'aria-selected':'false', 'role':'tab'});
                    $homeTabMenu.find('.btn-group a.on').attr({'aria-selected':'true', 'role':'tab'});
                }

                $homeTabMenu.find('.btn-group a').on('click',function(e){
                    e.preventDefault();

                    $homeTabMenu.find('.btn-group a').attr({'aria-selected':'false', 'role':'tab'});
                    $homeTabMenu.find('.btn-group a.on').attr({'aria-selected':'true', 'role':'tab'});
                });

                let unconfirmedEles = [
                    ...document?.querySelectorAll('.card-timeline-group'),
                    ...document?.querySelectorAll('.btn-quick-link')
                ].filter((item) => !!item && item);
            
                unconfirmedEles?.length && Array.from(unconfirmedEles).forEach((list) => {
                    const icoEle = list?.querySelector('.ico-quick');
                    const spanEle = list?.querySelector('.icon');
            
                    const isCheckNew = $(list).hasClass('unconfirmed');
            
                    if(icoEle){
                        icoEle?.removeAttribute('role','img');
                        icoEle?.setAttribute('aria-hidden','true');
                        icoEle.setAttribute('tabindex','-1');
            
                        if(isCheckNew){
                            icoEle?.setAttribute('role','img');
                            icoEle?.setAttribute('aria-hidden','false');
                            icoEle?.setAttribute('aria-label','새알림');
                            icoEle.setAttribute('tabindex','0');
                        }
                    }

                    if(spanEle){
                        spanEle?.setAttribute('aria-hidden','true');

                        if(isCheckNew){
                            spanEle?.removeAttribute('aria-hidden');
                        }
                    }
            
                });
            }
        });
    /*! s: FETASK-a11y page 메인 하단 tab버튼 접근성 v.1.0.0 */
    }, 10)
    return returnValue
}

// /**
//  * 메인 나타남 애니메이션과 스크롤 애니메이션 초기화
//  * @param index 메인 4개의 탭 index
//  * @param reset 애니메이션을 다시 실행함
//  */
export function mainRevealAnimationInitImpl(index, reset){

    // llog('mainRevealAnimationInitImpl', index, reset)
    if(index < 0 || index > 2){
        return;
    }

    mainRevealAnimationElInit();

    if(!$mainTab01){
        return;
    }

    if($(mainTabs[index]).hasClass('ui-animation')){
        return;
    }

    let visibleObject = mainTabAnimationEls[index].filter((el) => {
        return isInViewport(el, mainTabs[index])
    })

    let hideObject = mainTabAnimationEls[index].filter((el) => {
        return !isInViewport(el, mainTabs[index])
    })

    if(reset){
        $(mainTabAnimationEls[index]).css({transition: 'none'});
        $(mainTabAnimationEls[index]).removeClass('ui-animation')

        visibleObject = mainTabAnimationEls[index].filter((el) => {
            return isInViewport(el, mainTabs[index])
        })

        visibleObject.forEach((obj, idx) => {
            $(obj).addClass('ui-animation')
        })

        setTimeout(() => {
            $(mainTabAnimationEls[index]).css({transition: ''});
        })

    }else{
        visibleObject.forEach((obj, idx) => {
            // llog(obj)
            setTimeout(() => {
                $(obj).addClass('ui-animation')
            }, 20*idx)

        })
    }

    const windowInnerHeight = window.innerHeight;
    const eventListener = (e) => {
        const _this = e.target;
        const st = _this.scrollTop;

        hideObject.forEach((obj) => {
            const scroll = st + windowInnerHeight;
            const target = st + obj.getBoundingClientRect().top

            if(scroll > target){
                if (obj.classList.contains('ui-animation')) {
                    return;
                }
                obj.classList.add('ui-animation');
            }
        })
    };

    if($(mainTabs[index]).data('scrollEventListener')){
        mainTabs[index].removeEventListener('scroll', $(mainTabs[index]).data('scrollEventListener'), {passive: true})
    }
    mainTabs[index].addEventListener('scroll', eventListener, {passive: true})
    $(mainTabs[index]).data('scrollEventListener', eventListener);
}

// /**
//  * 복사한 계좌로 000원 이체할께요. 닫기 애니메이션
//  */
function closeComponent(){
    //llog('     start:: closeComponent')
    const $el = $('.main-tab-container');
    if(!$el[0] || $el.data('closeComponent')){
        return;
    }
    //llog('init:: closeComponent')
    $el.data('closeComponent', true);

    $el.on('click', '.btn-delete-txt', () => {
        mainRemitComponentClose();
    });
}

// /**
//  * 복사한 계좌로 000원 이체할께요. 닫기 애니메이션
//  */
export function mainRemitComponentClose(){
    const $el = $('.home-banner05-group');
    var returnValue = "mainRemitComponentClose";
    if(!$el[0]){
        return;
    }

    const el = $el.parent().get(0);
    const elInner = $el.get(0);

    const _tm = gsap.timeline();
    _tm.to(el, {duration: 0.4, delay: 0.1, marginTop: 0, overflow: 'hidden'})
    _tm.to(el, {duration: 0.4, height: 0, scale: 1, overflow: 'hidden'}, 0)
    _tm.to(elInner, {duration: 0.4, delay: 0.2, y: 10, overflow: 'hidden'}, 0)
    return returnValue;
}

// /**
//  * 우측상단 혜택 버튼 애니메이션
//  */
function animateBenefitBtn(options={}){
    const {firstBtn,secondBtn,thirdBtn} = {
        firstBtn : 'defalut',
        ...options
    };
    const $el = $('.main-tab-container');
    const season = ''
    const $benefitArea = $('.home-header-group.my-header-group').find('[data-benefit-area]');
    $benefitArea.css('align-items','baseline')

    if (firstBtn != undefined) {
        let oneHtml;
        if (firstBtn == 'defalut') { // 첫번째 버튼 defalut
            /*
            oneHtml = `
            <a class="btn-main-benefit" href="#none" onclick="goToEventMenu(this);">
                <span class="hide-txt">혜택</span>
                <span class="svg-main-benefit">
                <span class="box">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 32 32">
                    <defs>
                        <path id="a" d="M0 0h32v32H0z"></path>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <mask id="b" fill="#fff">
                        <use xlink:href="#a"></use>
                        </mask>
                        <g mask="url(#b)">
                        <g stroke="#17008C" stroke-width="2" transform="translate(4.833 4.2)">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.417 0c.918 0 1.707.57 2.057 1.388l1.693 3.279h-3.75c-1.243 0-2.25-1.045-2.25-2.334C5.167 1.045 6.174 0 7.417 0zm7.5 0c-.918 0-1.708.57-2.058 1.388l-1.692 3.279h3.75c1.242 0 2.25-1.045 2.25-2.334 0-1.288-1.008-2.333-2.25-2.333z"></path>
                            <rect width="21.67" height="19" x=".33" y="4.97" rx="2"></rect>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.33 5.47v17.5m-10-12.5l19.84.33"></path>
                        </g>
                        </g>
                    </g>
                    </svg>
                </span>
                <span class="money">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                    <g fill="none" fill-rule="evenodd">
                    <circle cx="9.5" cy="9.5" r="8.5" fill="#FFF" stroke="#17008C" stroke-width="2" />
                    <circle cx="9.5" cy="9.5" r="7.5" fill="#B6F23D" style="mix-blend-mode:multiply" />
                    <path stroke="#17008C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M6.071 7l1.696 5 1.725-5 1.593 5 1.844-5M5 9.31h1.714m5.572 0H14" />
                    </g>
                </svg>
                </span>
                </span>
            </a>
            `
            */

            /*! s: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */
            oneHtml = `
            <a class="btn-main-benefit" href="#none" onclick="goToEventMenu(this);" role="button">
                <span class="hide-txt">혜택</span>
                <span class="svg-main-benefit" aria-hidden="true">
                    <span class="box">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 32 32">
                            <defs>
                                <path id="a" d="M0 0h32v32H0z"></path>
                            </defs>
                            <g fill="none" fill-rule="evenodd">
                                <mask id="b" fill="#fff">
                                <use xlink:href="#a"></use>
                                </mask>
                                <g mask="url(#b)">
                                <g stroke="#17008C" stroke-width="2" transform="translate(4.833 4.2)">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.417 0c.918 0 1.707.57 2.057 1.388l1.693 3.279h-3.75c-1.243 0-2.25-1.045-2.25-2.334C5.167 1.045 6.174 0 7.417 0zm7.5 0c-.918 0-1.708.57-2.058 1.388l-1.692 3.279h3.75c1.242 0 2.25-1.045 2.25-2.334 0-1.288-1.008-2.333-2.25-2.333z"></path>
                                    <rect width="21.67" height="19" x=".33" y="4.97" rx="2"></rect>
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.33 5.47v17.5m-10-12.5l19.84.33"></path>
                                </g>
                                </g>
                            </g>
                        </svg>
                    </span>
                    <span class="money">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                            <g fill="none" fill-rule="evenodd">
                            <circle cx="9.5" cy="9.5" r="8.5" fill="#FFF" stroke="#17008C" stroke-width="2" />
                            <circle cx="9.5" cy="9.5" r="7.5" fill="#B6F23D" style="mix-blend-mode:multiply" />
                            <path stroke="#17008C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M6.071 7l1.696 5 1.725-5 1.593 5 1.844-5M5 9.31h1.714m5.572 0H14" />
                            </g>
                        </svg>
                    </span>
                </span>
            </a>
            `
            /*! e: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */

        } else { // 첫번재 버튼 시즌
            oneHtml =  ``
        }
        if (!$('.btn-main-benefit').length > 0) {
            $benefitArea.attr('benefit-len', 2)
            $benefitArea.prepend(oneHtml);
        }
        $el.data('animateBenefitBtn', false)
    }
    if (secondBtn != undefined) {
        let twoHtml;
        if (secondBtn == 'defalut') { // 두번재 버튼 defalut
            /*
            twoHtml = `
            <style type="text/css">
            .benefit-two{display:block;height: 30px;width: 130px;display: flex;}
            .benefit-two .msg{width:85px;margin-right:11px;}
            .benefit-two .msg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#b6f23d;}
            .benefit-two .msg .st1{fill:#17008c;}
            .benefit-two .benefit-two-icon{width: 26px;height:26px;position:relative;}
            .benefit-two .benefit-two-icon [class^="benefit-two-item"]{position:absolute;top:0;right:0;width: 26px;height:26px;}
            .benefit-two .benefit-two-icon .benefit-two-item01{display:block;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st0{fill:#b6f23d;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st1{fill:none;stroke:#17008C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st2{fill:none;stroke:#17008C;stroke-width:2.1543;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            </style>
            <a href="#none" class="benefit-two" data-id="seasenMenuBanner">
                <span class="hide-txt">오늘도 출첵</span>
                <div class="msg" aria-hidden="true">
                    <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 97.8 30" style="enable-background:new 0 0 97.8 30;" xml:space="preserve">
                        <g id="Layer_1-2">
                            <g>
                                <polygon id="Rectangle" class="st0" points="83.5,14.4 90.6,10.1 97.6,14.4 90.6,18.7 		"/>
                                <path id="Rectangle-2" class="st0" d="M8.4,0h74.4c4.4,0,8,3.6,8,8v14c0,4.4-3.6,8-8,8H8.4c-4.4,0-8-3.6-8-8V8
                                    C0.4,3.6,3.9,0,8.4,0z"/>
                                <g>
                                    <path class="st1" d="M24.1,13.1c0,1.9-1.6,3.2-4,3.5v2.2h5v1.5H13.4v-1.5h4.9v-2.2c-2.3-0.3-3.9-1.6-3.9-3.5
                                        c0-2.1,2.1-3.5,4.8-3.5S24.1,11,24.1,13.1L24.1,13.1z M19.3,15.2c1.8,0,3-0.8,3.1-2.1c0-1.3-1.2-2.1-3.1-2.1c-1.8,0-3,0.8-3,2.1
                                        C16.2,14.5,17.5,15.2,19.3,15.2z"/>
                                    <path class="st1" d="M25.9,13.8h11.7v1.4H25.9C25.9,15.2,25.9,13.8,25.9,13.8z M27.2,16h9v3.4h-7.2v0.8h7.6v1.4h-9.4v-3.5h7.2
                                        v-0.7h-7.2L27.2,16L27.2,16z M36.3,13h-8.9V9.1h1.8v2.4h7.1V13z"/>
                                    <path class="st1" d="M48.8,16.1h-3.7v2.7h5v1.5H38.4v-1.5h5v-2.7h-3.6V9.8h9v1.4h-7.2v3.4h7.3L48.8,16.1L48.8,16.1z"/>
                                    <path class="st1" d="M65.8,15.7h-4.9v0.8h3.5v3.1h-7.2v0.7h7.5v1.3h-9.3v-3.2h7.1v-0.6h-7.2v-1.3h3.6v-0.8h-4.9v-1.3h11.7
                                        L65.8,15.7L65.8,15.7z M58.9,11.3h-3.6V9.9h3.8v-1h1.8v1h3.9v1.3h-3.6c0.4,0.7,1.7,1.4,4.3,1.5l-0.5,1.3c-2.4-0.1-4-0.7-4.9-1.7
                                        c-0.8,1-2.5,1.6-4.9,1.7l-0.5-1.3C57.2,12.6,58.5,12,58.9,11.3z"/>
                                    <path class="st1" d="M73.1,15.1l-0.8,1.3c-1.1-0.4-1.9-1.1-2.4-2.1c-0.4,1-1.2,1.8-2.4,2.3l-0.8-1.4c1.6-0.6,2.3-1.9,2.3-3.3
                                        v-0.1h-2v-1.4h2V9.1h1.7v1.3h2v1.4h-2V12C70.7,13.2,71.4,14.5,73.1,15.1z M68.8,17.3h8.9v4.4h-1.8v-3h-7.1V17.3z M72.1,12.5h1.4
                                        V9.2h1.7v7.6h-1.7v-2.8h-1.4V12.5L72.1,12.5z M76,8.9h1.7v7.9H76C76,16.8,76,8.9,76,8.9z"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="benefit-two-icon">
                    <div class="benefit-two-item01">
                        <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">
                        <path class="st0" fill="#B6F23D" d="M25.3,12.5H3.1c0,0-1.1-5.6,0.1-7s20-1.2,21.3-0.1C25.7,6.4,25.3,12.5,25.3,12.5z"></path>
                        <path class="st1" fill="none" stroke="#17008C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4.6667" d="M25.1,19.8v4.8c0,1.4-1.1,2.4-2.4,2.4H5.3c-1.4,0-2.4-1.1-2.4-2.4V7.3C2.9,6,4,4.9,5.3,4.9h17.2
                            C23.9,4.9,25,6,25,7.3v5 M19,2.4v5 M9,2.4v5 M2.9,12.3H25"></path>
                        <path class="st2" fill="none" stroke="#17008C" stroke-width="2.1543" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4.6667" d="M14.2,19l3.6,3.9l7.2-7.7"></path>
                        </svg>
                    </div>
                </div>

            </a>
            `
            */

            /*! s: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */
            twoHtml = `
            <style type="text/css">
            .benefit-two{display:block;height: 30px;width: 130px;display: flex;}
            .benefit-two .msg{width:85px;margin-right:11px;}
            .benefit-two .msg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#b6f23d;}
            .benefit-two .msg .st1{fill:#17008c;}
            .benefit-two .benefit-two-icon{width: 26px;height:26px;position:relative;}
            .benefit-two .benefit-two-icon [class^="benefit-two-item"]{position:absolute;top:0;right:0;width: 26px;height:26px;}
            .benefit-two .benefit-two-icon .benefit-two-item01{display:block;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st0{fill:#b6f23d;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st1{fill:none;stroke:#17008C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st2{fill:none;stroke:#17008C;stroke-width:2.1543;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            </style>
            <a href="#none" class="benefit-two" data-id="seasenMenuBanner" role="button">
                <span class="hide-txt">오늘도 출첵</span>
                <div class="msg" aria-hidden="true">
                    <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 97.8 30" style="enable-background:new 0 0 97.8 30;" xml:space="preserve">
                        <g id="Layer_1-2">
                            <g>
                                <polygon id="Rectangle" class="st0" points="83.5,14.4 90.6,10.1 97.6,14.4 90.6,18.7 		"/>
                                <path id="Rectangle-2" class="st0" d="M8.4,0h74.4c4.4,0,8,3.6,8,8v14c0,4.4-3.6,8-8,8H8.4c-4.4,0-8-3.6-8-8V8
                                    C0.4,3.6,3.9,0,8.4,0z"/>
                                <g>
                                    <path class="st1" d="M24.1,13.1c0,1.9-1.6,3.2-4,3.5v2.2h5v1.5H13.4v-1.5h4.9v-2.2c-2.3-0.3-3.9-1.6-3.9-3.5
                                        c0-2.1,2.1-3.5,4.8-3.5S24.1,11,24.1,13.1L24.1,13.1z M19.3,15.2c1.8,0,3-0.8,3.1-2.1c0-1.3-1.2-2.1-3.1-2.1c-1.8,0-3,0.8-3,2.1
                                        C16.2,14.5,17.5,15.2,19.3,15.2z"/>
                                    <path class="st1" d="M25.9,13.8h11.7v1.4H25.9C25.9,15.2,25.9,13.8,25.9,13.8z M27.2,16h9v3.4h-7.2v0.8h7.6v1.4h-9.4v-3.5h7.2
                                        v-0.7h-7.2L27.2,16L27.2,16z M36.3,13h-8.9V9.1h1.8v2.4h7.1V13z"/>
                                    <path class="st1" d="M48.8,16.1h-3.7v2.7h5v1.5H38.4v-1.5h5v-2.7h-3.6V9.8h9v1.4h-7.2v3.4h7.3L48.8,16.1L48.8,16.1z"/>
                                    <path class="st1" d="M65.8,15.7h-4.9v0.8h3.5v3.1h-7.2v0.7h7.5v1.3h-9.3v-3.2h7.1v-0.6h-7.2v-1.3h3.6v-0.8h-4.9v-1.3h11.7
                                        L65.8,15.7L65.8,15.7z M58.9,11.3h-3.6V9.9h3.8v-1h1.8v1h3.9v1.3h-3.6c0.4,0.7,1.7,1.4,4.3,1.5l-0.5,1.3c-2.4-0.1-4-0.7-4.9-1.7
                                        c-0.8,1-2.5,1.6-4.9,1.7l-0.5-1.3C57.2,12.6,58.5,12,58.9,11.3z"/>
                                    <path class="st1" d="M73.1,15.1l-0.8,1.3c-1.1-0.4-1.9-1.1-2.4-2.1c-0.4,1-1.2,1.8-2.4,2.3l-0.8-1.4c1.6-0.6,2.3-1.9,2.3-3.3
                                        v-0.1h-2v-1.4h2V9.1h1.7v1.3h2v1.4h-2V12C70.7,13.2,71.4,14.5,73.1,15.1z M68.8,17.3h8.9v4.4h-1.8v-3h-7.1V17.3z M72.1,12.5h1.4
                                        V9.2h1.7v7.6h-1.7v-2.8h-1.4V12.5L72.1,12.5z M76,8.9h1.7v7.9H76C76,16.8,76,8.9,76,8.9z"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="benefit-two-icon" aria-hidden="true">
                    <div class="benefit-two-item01">
                        <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">
                            <path class="st0" fill="#B6F23D" d="M25.3,12.5H3.1c0,0-1.1-5.6,0.1-7s20-1.2,21.3-0.1C25.7,6.4,25.3,12.5,25.3,12.5z"></path>
                            <path class="st1" fill="none" stroke="#17008C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4.6667" d="M25.1,19.8v4.8c0,1.4-1.1,2.4-2.4,2.4H5.3c-1.4,0-2.4-1.1-2.4-2.4V7.3C2.9,6,4,4.9,5.3,4.9h17.2
                                C23.9,4.9,25,6,25,7.3v5 M19,2.4v5 M9,2.4v5 M2.9,12.3H25"></path>
                            <path class="st2" fill="none" stroke="#17008C" stroke-width="2.1543" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4.6667" d="M14.2,19l3.6,3.9l7.2-7.7"></path>
                        </svg>
                    </div>
                </div>
            </a>
            `
            /*! e: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */
        } else { // 두번재 버튼 시즌
            /*
            twoHtml = `
            <style type="text/css">
            .benefit-two{display:block;height: 30px;width: 120px;display: flex;}
            .benefit-two .msg{width:78px;margin-right:11px;}
            .benefit-two .msg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#b6f23d;}
            .benefit-two .msg .st1{fill:#17008c;}
            .benefit-two .benefit-two-icon{width: 26px;height:26px;position:relative;}
            .benefit-two .benefit-two-icon [class^="benefit-two-item"]{position:absolute;top:0;right:0;width: 26px;height:26px;}
            .benefit-two .benefit-two-icon .benefit-two-item01{display:block;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st0{fill:#b6f23d;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st1{fill:none;stroke:#17008C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st2{fill:none;stroke:#17008C;stroke-width:2.1543;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            </style>
            <a href="#none" class="benefit-two" data-id="seasenMenuBanner">
                <span class="hide-txt">최대 10만원</span>
                <div class="msg">
                <svg width="78" height="25" viewBox="0 0 78 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.81223 0H67.9167C71.2497 0 73.9517 2.98477 73.9517 6.66667V18.3333C73.9517 22.0152 71.2497 25 67.9167 25H6.81223C3.47919 25 0.777222 22.0152 0.777222 18.3333V6.66667C0.777222 2.98477 3.47919 0 6.81223 0Z" fill="#C8F03E"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M67.1087 12.5L72.443 7.44078L77.7772 12.5L72.443 17.5592L67.1087 12.5Z" fill="#C8F03E"/>
                <path d="M13.371 13.7852C14.3202 13.7266 15.1835 13.6406 15.9608 13.5273L16.078 14.6172C15.035 14.8164 13.9725 14.9453 12.8905 15.0039C11.8124 15.0625 10.621 15.0938 9.31628 15.0977L9.1405 13.8906C10.1718 13.8906 11.0858 13.8789 11.8827 13.8555V12.1797H13.371V13.7852ZM9.35144 11.3828C10.1249 11.1758 10.7206 10.8496 11.1385 10.4043C11.5604 9.95508 11.7968 9.44531 11.8475 8.875H9.69128V7.66797H11.8827V6.50781H13.371V7.66797H15.5741V8.875H13.3944C13.4296 9.23047 13.5448 9.56641 13.7401 9.88281C13.9354 10.1953 14.2147 10.4727 14.578 10.7148C14.9413 10.957 15.3827 11.1406 15.9022 11.2656L15.2225 12.4258C14.6132 12.2734 14.0897 12.0352 13.6522 11.7109C13.2186 11.3828 12.8768 10.9902 12.6268 10.5332C12.3885 11.0137 12.0526 11.4238 11.619 11.7637C11.1893 12.1035 10.6678 12.3516 10.0546 12.5078L9.35144 11.3828ZM16.5702 6.41406H18.0585V17.1016H16.5702V6.41406ZM28.6874 17.0781H27.2694V11.7227H26.2382V16.5625H24.8671V6.58984H26.2382V10.5273H27.2694V6.41406H28.6874V17.0781ZM19.7694 7.64453H23.7421V8.85156H21.2694V13.4102C21.8241 13.4023 22.3358 13.3789 22.8046 13.3398C23.2772 13.3008 23.7577 13.2383 24.246 13.1523L24.3514 14.3711C23.7499 14.4844 23.1581 14.5605 22.576 14.5996C21.994 14.6387 21.3046 14.6602 20.5077 14.6641H19.7694V7.64453ZM36.6093 16H34.8397V9.19141H34.7928L32.8475 10.4102V8.85156L34.9452 7.51562H36.6093V16ZM41.871 16.1172C41.1639 16.1172 40.5546 15.9473 40.0428 15.6074C39.5311 15.2637 39.1385 14.7656 38.8651 14.1133C38.5956 13.4609 38.4608 12.6758 38.4608 11.7578C38.4608 10.8438 38.5975 10.0605 38.871 9.4082C39.1444 8.75195 39.537 8.25391 40.0487 7.91406C40.5604 7.57031 41.1678 7.39844 41.871 7.39844C42.5741 7.39844 43.1815 7.57031 43.6932 7.91406C44.205 8.25391 44.5975 8.75195 44.871 9.4082C45.1444 10.0605 45.2811 10.8438 45.2811 11.7578C45.2811 12.6797 45.1444 13.4668 44.871 14.1191C44.5975 14.7715 44.205 15.2676 43.6932 15.6074C43.1854 15.9473 42.578 16.1172 41.871 16.1172ZM40.2655 11.8105C40.2655 12.748 40.4081 13.459 40.6932 13.9434C40.9784 14.4238 41.371 14.6641 41.871 14.6641C42.3749 14.6641 42.7694 14.4199 43.0546 13.9316C43.3397 13.4395 43.4803 12.7148 43.4764 11.7578C43.4764 11.125 43.412 10.5918 43.2831 10.1582C43.1542 9.7207 42.9686 9.39258 42.7264 9.17383C42.4843 8.95508 42.1991 8.84375 41.871 8.83984C41.3671 8.84375 40.9725 9.09766 40.6874 9.60156C40.4061 10.1055 40.2655 10.8418 40.2655 11.8105ZM51.5858 12.4141H46.4647V7.29297H51.5858V12.4141ZM47.6952 13.4336H49.1835V15.6953H54.996V16.8906H47.6952V13.4336ZM50.1093 11.2422V8.48828H47.9413V11.2422H50.1093ZM53.1093 6.41406H54.6093V9.48438H56.0507V10.7148H54.6093V14.1953H53.1093V6.41406ZM65.5546 14.4766H64.0546V13.6328H62.0155V12.6133H64.0546V6.42578H65.5546V14.4766ZM56.4843 11.1484C57.8241 11.1406 59.0507 11.1172 60.1639 11.0781C61.2772 11.0352 62.3319 10.9531 63.328 10.832L63.41 11.8984C62.5975 12.0352 61.7382 12.1367 60.8319 12.2031V14.2305H59.3319V15.6953H65.7889V16.8906H57.8436V13.7031H59.3319V12.291C58.5897 12.3184 57.6991 12.332 56.66 12.332L56.4843 11.1484ZM57.2694 8.69922C57.2694 8.32422 57.3827 7.99219 57.6093 7.70312C57.8358 7.41406 58.1522 7.18945 58.5585 7.0293C58.9647 6.86914 59.4296 6.78906 59.953 6.78906C60.4647 6.78906 60.9218 6.86914 61.3241 7.0293C61.7264 7.18945 62.0409 7.41406 62.2675 7.70312C62.4979 7.99219 62.6132 8.32422 62.6132 8.69922C62.6132 9.07422 62.4979 9.4043 62.2675 9.68945C62.0409 9.97461 61.7264 10.1934 61.3241 10.3457C60.9218 10.498 60.4647 10.5742 59.953 10.5742C59.4257 10.5742 58.9589 10.498 58.5526 10.3457C58.1503 10.1934 57.8358 9.97461 57.6093 9.68945C57.3827 9.4043 57.2694 9.07422 57.2694 8.69922ZM58.6874 8.69922C58.6835 8.95312 58.7968 9.15039 59.0272 9.29102C59.2616 9.42773 59.578 9.49609 59.9764 9.49609C60.3358 9.49609 60.6268 9.42578 60.8495 9.28516C61.076 9.14453 61.1913 8.94922 61.1952 8.69922C61.1913 8.44141 61.0741 8.24023 60.8436 8.0957C60.6171 7.95117 60.3202 7.87891 59.953 7.87891C59.5663 7.87891 59.2577 7.95117 59.0272 8.0957C58.7968 8.24023 58.6835 8.44141 58.6874 8.69922Z" fill="#140086"/>
                </svg>
                </div>
                <div class="benefit-two-icon">
                <div class="benefit-two-item01">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3330_15572)">
                <path d="M12.7772 11.8784L12.7772 5.58447" stroke="#140086" stroke-width="2"/>
                <path d="M21.7226 3.17877C21.8125 2.91815 21.7908 2.63198 21.6626 2.38787C21.5345 2.14377 21.3113 1.9634 21.0457 1.88937C19.8212 1.54806 17.9907 1.42534 16.3613 1.88187C14.6942 2.34894 13.0666 3.49527 12.7849 5.75704C12.7288 6.20767 12.9833 6.63955 13.4047 6.8087C14.4912 7.24476 16.1429 7.44675 17.7332 7.00516C19.3773 6.54864 20.9571 5.3976 21.7226 3.17877Z" fill="#B6F23D" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.83189 3.17877C3.74198 2.91815 3.76366 2.63198 3.8918 2.38787C4.01993 2.14377 4.24316 1.9634 4.50873 1.88937C5.73326 1.54806 7.56377 1.42534 9.19317 1.88187C10.8602 2.34894 12.4878 3.49527 12.7696 5.75704C12.8257 6.20767 12.5711 6.63955 12.1497 6.8087C11.0633 7.24476 9.41151 7.44675 7.8212 7.00516C6.17718 6.54864 4.59732 5.3976 3.83189 3.17877Z" fill="#B6F23D" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="3" y="19.5845" width="17" height="4" stroke="#140086" stroke-width="2" stroke-linejoin="round"/>
                <rect x="3" y="11.5845" width="17" height="4" stroke="#140086" stroke-width="2" stroke-linejoin="round"/>
                <rect x="6" y="15.5845" width="17" height="4" stroke="#140086" stroke-width="2" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_3330_15572">
                <rect width="24" height="24" fill="white" transform="translate(0.777222 0.584473)"/>
                </clipPath>
                </defs>
                </svg>
                </div>
                </div>

            </a>
            `
            */

            /*! s: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */
            twoHtml = `
            <style type="text/css">
            .benefit-two{display:block;height: 30px;width: 120px;display: flex;}
            .benefit-two .msg{width:78px;margin-right:11px;}
            .benefit-two .msg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#b6f23d;}
            .benefit-two .msg .st1{fill:#17008c;}
            .benefit-two .benefit-two-icon{width: 26px;height:26px;position:relative;}
            .benefit-two .benefit-two-icon [class^="benefit-two-item"]{position:absolute;top:0;right:0;width: 26px;height:26px;}
            .benefit-two .benefit-two-icon .benefit-two-item01{display:block;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st0{fill:#b6f23d;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st1{fill:none;stroke:#17008C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            .benefit-two .benefit-two-icon .benefit-two-item01 .st2{fill:none;stroke:#17008C;stroke-width:2.1543;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            </style>
            <a href="#none" class="benefit-two" data-id="seasenMenuBanner" role="button">
                <span class="hide-txt">최대 10만원</span>
                <div class="msg" aria-hidden="true">
                    <svg width="78" height="25" viewBox="0 0 78 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.81223 0H67.9167C71.2497 0 73.9517 2.98477 73.9517 6.66667V18.3333C73.9517 22.0152 71.2497 25 67.9167 25H6.81223C3.47919 25 0.777222 22.0152 0.777222 18.3333V6.66667C0.777222 2.98477 3.47919 0 6.81223 0Z" fill="#C8F03E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M67.1087 12.5L72.443 7.44078L77.7772 12.5L72.443 17.5592L67.1087 12.5Z" fill="#C8F03E"/>
                    <path d="M13.371 13.7852C14.3202 13.7266 15.1835 13.6406 15.9608 13.5273L16.078 14.6172C15.035 14.8164 13.9725 14.9453 12.8905 15.0039C11.8124 15.0625 10.621 15.0938 9.31628 15.0977L9.1405 13.8906C10.1718 13.8906 11.0858 13.8789 11.8827 13.8555V12.1797H13.371V13.7852ZM9.35144 11.3828C10.1249 11.1758 10.7206 10.8496 11.1385 10.4043C11.5604 9.95508 11.7968 9.44531 11.8475 8.875H9.69128V7.66797H11.8827V6.50781H13.371V7.66797H15.5741V8.875H13.3944C13.4296 9.23047 13.5448 9.56641 13.7401 9.88281C13.9354 10.1953 14.2147 10.4727 14.578 10.7148C14.9413 10.957 15.3827 11.1406 15.9022 11.2656L15.2225 12.4258C14.6132 12.2734 14.0897 12.0352 13.6522 11.7109C13.2186 11.3828 12.8768 10.9902 12.6268 10.5332C12.3885 11.0137 12.0526 11.4238 11.619 11.7637C11.1893 12.1035 10.6678 12.3516 10.0546 12.5078L9.35144 11.3828ZM16.5702 6.41406H18.0585V17.1016H16.5702V6.41406ZM28.6874 17.0781H27.2694V11.7227H26.2382V16.5625H24.8671V6.58984H26.2382V10.5273H27.2694V6.41406H28.6874V17.0781ZM19.7694 7.64453H23.7421V8.85156H21.2694V13.4102C21.8241 13.4023 22.3358 13.3789 22.8046 13.3398C23.2772 13.3008 23.7577 13.2383 24.246 13.1523L24.3514 14.3711C23.7499 14.4844 23.1581 14.5605 22.576 14.5996C21.994 14.6387 21.3046 14.6602 20.5077 14.6641H19.7694V7.64453ZM36.6093 16H34.8397V9.19141H34.7928L32.8475 10.4102V8.85156L34.9452 7.51562H36.6093V16ZM41.871 16.1172C41.1639 16.1172 40.5546 15.9473 40.0428 15.6074C39.5311 15.2637 39.1385 14.7656 38.8651 14.1133C38.5956 13.4609 38.4608 12.6758 38.4608 11.7578C38.4608 10.8438 38.5975 10.0605 38.871 9.4082C39.1444 8.75195 39.537 8.25391 40.0487 7.91406C40.5604 7.57031 41.1678 7.39844 41.871 7.39844C42.5741 7.39844 43.1815 7.57031 43.6932 7.91406C44.205 8.25391 44.5975 8.75195 44.871 9.4082C45.1444 10.0605 45.2811 10.8438 45.2811 11.7578C45.2811 12.6797 45.1444 13.4668 44.871 14.1191C44.5975 14.7715 44.205 15.2676 43.6932 15.6074C43.1854 15.9473 42.578 16.1172 41.871 16.1172ZM40.2655 11.8105C40.2655 12.748 40.4081 13.459 40.6932 13.9434C40.9784 14.4238 41.371 14.6641 41.871 14.6641C42.3749 14.6641 42.7694 14.4199 43.0546 13.9316C43.3397 13.4395 43.4803 12.7148 43.4764 11.7578C43.4764 11.125 43.412 10.5918 43.2831 10.1582C43.1542 9.7207 42.9686 9.39258 42.7264 9.17383C42.4843 8.95508 42.1991 8.84375 41.871 8.83984C41.3671 8.84375 40.9725 9.09766 40.6874 9.60156C40.4061 10.1055 40.2655 10.8418 40.2655 11.8105ZM51.5858 12.4141H46.4647V7.29297H51.5858V12.4141ZM47.6952 13.4336H49.1835V15.6953H54.996V16.8906H47.6952V13.4336ZM50.1093 11.2422V8.48828H47.9413V11.2422H50.1093ZM53.1093 6.41406H54.6093V9.48438H56.0507V10.7148H54.6093V14.1953H53.1093V6.41406ZM65.5546 14.4766H64.0546V13.6328H62.0155V12.6133H64.0546V6.42578H65.5546V14.4766ZM56.4843 11.1484C57.8241 11.1406 59.0507 11.1172 60.1639 11.0781C61.2772 11.0352 62.3319 10.9531 63.328 10.832L63.41 11.8984C62.5975 12.0352 61.7382 12.1367 60.8319 12.2031V14.2305H59.3319V15.6953H65.7889V16.8906H57.8436V13.7031H59.3319V12.291C58.5897 12.3184 57.6991 12.332 56.66 12.332L56.4843 11.1484ZM57.2694 8.69922C57.2694 8.32422 57.3827 7.99219 57.6093 7.70312C57.8358 7.41406 58.1522 7.18945 58.5585 7.0293C58.9647 6.86914 59.4296 6.78906 59.953 6.78906C60.4647 6.78906 60.9218 6.86914 61.3241 7.0293C61.7264 7.18945 62.0409 7.41406 62.2675 7.70312C62.4979 7.99219 62.6132 8.32422 62.6132 8.69922C62.6132 9.07422 62.4979 9.4043 62.2675 9.68945C62.0409 9.97461 61.7264 10.1934 61.3241 10.3457C60.9218 10.498 60.4647 10.5742 59.953 10.5742C59.4257 10.5742 58.9589 10.498 58.5526 10.3457C58.1503 10.1934 57.8358 9.97461 57.6093 9.68945C57.3827 9.4043 57.2694 9.07422 57.2694 8.69922ZM58.6874 8.69922C58.6835 8.95312 58.7968 9.15039 59.0272 9.29102C59.2616 9.42773 59.578 9.49609 59.9764 9.49609C60.3358 9.49609 60.6268 9.42578 60.8495 9.28516C61.076 9.14453 61.1913 8.94922 61.1952 8.69922C61.1913 8.44141 61.0741 8.24023 60.8436 8.0957C60.6171 7.95117 60.3202 7.87891 59.953 7.87891C59.5663 7.87891 59.2577 7.95117 59.0272 8.0957C58.7968 8.24023 58.6835 8.44141 58.6874 8.69922Z" fill="#140086"/>
                    </svg>
                </div>
                <div class="benefit-two-icon" aria-hidden="true">
                    <div class="benefit-two-item01">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3330_15572)">
                        <path d="M12.7772 11.8784L12.7772 5.58447" stroke="#140086" stroke-width="2"/>
                        <path d="M21.7226 3.17877C21.8125 2.91815 21.7908 2.63198 21.6626 2.38787C21.5345 2.14377 21.3113 1.9634 21.0457 1.88937C19.8212 1.54806 17.9907 1.42534 16.3613 1.88187C14.6942 2.34894 13.0666 3.49527 12.7849 5.75704C12.7288 6.20767 12.9833 6.63955 13.4047 6.8087C14.4912 7.24476 16.1429 7.44675 17.7332 7.00516C19.3773 6.54864 20.9571 5.3976 21.7226 3.17877Z" fill="#B6F23D" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3.83189 3.17877C3.74198 2.91815 3.76366 2.63198 3.8918 2.38787C4.01993 2.14377 4.24316 1.9634 4.50873 1.88937C5.73326 1.54806 7.56377 1.42534 9.19317 1.88187C10.8602 2.34894 12.4878 3.49527 12.7696 5.75704C12.8257 6.20767 12.5711 6.63955 12.1497 6.8087C11.0633 7.24476 9.41151 7.44675 7.8212 7.00516C6.17718 6.54864 4.59732 5.3976 3.83189 3.17877Z" fill="#B6F23D" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <rect x="3" y="19.5845" width="17" height="4" stroke="#140086" stroke-width="2" stroke-linejoin="round"/>
                        <rect x="3" y="11.5845" width="17" height="4" stroke="#140086" stroke-width="2" stroke-linejoin="round"/>
                        <rect x="6" y="15.5845" width="17" height="4" stroke="#140086" stroke-width="2" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_3330_15572">
                        <rect width="24" height="24" fill="white" transform="translate(0.777222 0.584473)"/>
                        </clipPath>
                        </defs>
                        </svg>
                    </div>
                </div>
            </a>
            `
            /*! e: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */

        }
        if (!$('.benefit-two').length > 0) {
            $benefitArea.prepend(twoHtml);
        }
        $el.data('animateBenefitBtn', false)
    }
    if (thirdBtn != undefined) {
        let threeHtml;
        if (thirdBtn == 'defalut') { // 세번재 버튼 defalut
            threeHtml =
`
`
        } else { // 세번재 버튼 시즌
            /*
            threeHtml = `
            <style type="text/css">
            .benefit-three{display:block;height: 30px;width: 130px;display: flex;margin-right:10px;}
            .benefit-three .msg{width:85px;margin-right:11px;}
            .benefit-three .msg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#b6f23d;}
            .benefit-three .msg .st1{fill:#17008c;}
            .benefit-three .benefit-three-icon{width: 26px;height:26px;position:relative;}
            .benefit-three .benefit-three-icon [class^="benefit-three-item"]{position:absolute;top:0;right:0;width: 26px;height:26px;}
            .benefit-three .benefit-three-icon .benefit-three-item01{display:block;}
            .benefit-three .benefit-three-icon .benefit-three-item01 .st0{fill:#b6f23d;}
            .benefit-three .benefit-three-icon .benefit-three-item01 .st1{fill:none;stroke:#17008C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            .benefit-three .benefit-three-icon .benefit-three-item01 .st2{fill:none;stroke:#17008C;stroke-width:2.1543;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            [benefit-len="3"] .benefit-two{flex:1; width:auto;margin-right:8px;}
            [benefit-len="3"] .benefit-two .msg{display:none}
            </style>
            <a href="#none" class="benefit-three" data-id="seasenMenuBanner2">
                <span class="hide-txt">오늘도 출첵</span>
                <div class="msg">
                <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 97.8 30" style="enable-background:new 0 0 97.8 30;" xml:space="preserve">
                <g id="Layer_1-2">
                    <g>
                        <polygon id="Rectangle" class="st0" points="83.5,14.4 90.6,10.1 97.6,14.4 90.6,18.7 		"/>
                        <path id="Rectangle-2" class="st0" d="M8.4,0h74.4c4.4,0,8,3.6,8,8v14c0,4.4-3.6,8-8,8H8.4c-4.4,0-8-3.6-8-8V8
                            C0.4,3.6,3.9,0,8.4,0z"/>
                        <g>
                            <path class="st1" d="M24.1,13.1c0,1.9-1.6,3.2-4,3.5v2.2h5v1.5H13.4v-1.5h4.9v-2.2c-2.3-0.3-3.9-1.6-3.9-3.5
                                c0-2.1,2.1-3.5,4.8-3.5S24.1,11,24.1,13.1L24.1,13.1z M19.3,15.2c1.8,0,3-0.8,3.1-2.1c0-1.3-1.2-2.1-3.1-2.1c-1.8,0-3,0.8-3,2.1
                                C16.2,14.5,17.5,15.2,19.3,15.2z"/>
                            <path class="st1" d="M25.9,13.8h11.7v1.4H25.9C25.9,15.2,25.9,13.8,25.9,13.8z M27.2,16h9v3.4h-7.2v0.8h7.6v1.4h-9.4v-3.5h7.2
                                v-0.7h-7.2L27.2,16L27.2,16z M36.3,13h-8.9V9.1h1.8v2.4h7.1V13z"/>
                            <path class="st1" d="M48.8,16.1h-3.7v2.7h5v1.5H38.4v-1.5h5v-2.7h-3.6V9.8h9v1.4h-7.2v3.4h7.3L48.8,16.1L48.8,16.1z"/>
                            <path class="st1" d="M65.8,15.7h-4.9v0.8h3.5v3.1h-7.2v0.7h7.5v1.3h-9.3v-3.2h7.1v-0.6h-7.2v-1.3h3.6v-0.8h-4.9v-1.3h11.7
                                L65.8,15.7L65.8,15.7z M58.9,11.3h-3.6V9.9h3.8v-1h1.8v1h3.9v1.3h-3.6c0.4,0.7,1.7,1.4,4.3,1.5l-0.5,1.3c-2.4-0.1-4-0.7-4.9-1.7
                                c-0.8,1-2.5,1.6-4.9,1.7l-0.5-1.3C57.2,12.6,58.5,12,58.9,11.3z"/>
                            <path class="st1" d="M73.1,15.1l-0.8,1.3c-1.1-0.4-1.9-1.1-2.4-2.1c-0.4,1-1.2,1.8-2.4,2.3l-0.8-1.4c1.6-0.6,2.3-1.9,2.3-3.3
                                v-0.1h-2v-1.4h2V9.1h1.7v1.3h2v1.4h-2V12C70.7,13.2,71.4,14.5,73.1,15.1z M68.8,17.3h8.9v4.4h-1.8v-3h-7.1V17.3z M72.1,12.5h1.4
                                V9.2h1.7v7.6h-1.7v-2.8h-1.4V12.5L72.1,12.5z M76,8.9h1.7v7.9H76C76,16.8,76,8.9,76,8.9z"/>
                        </g>
                    </g>
                </g>
                </svg>
                </div>
                <div class="benefit-three-icon">
                <div class="benefit-three-item01">
                <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">
                    <path class="st0" fill="#B6F23D" d="M25.3,12.5H3.1c0,0-1.1-5.6,0.1-7s20-1.2,21.3-0.1C25.7,6.4,25.3,12.5,25.3,12.5z"></path>
                    <path class="st1" fill="none" stroke="#17008C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4.6667" d="M25.1,19.8v4.8c0,1.4-1.1,2.4-2.4,2.4H5.3c-1.4,0-2.4-1.1-2.4-2.4V7.3C2.9,6,4,4.9,5.3,4.9h17.2
                        C23.9,4.9,25,6,25,7.3v5 M19,2.4v5 M9,2.4v5 M2.9,12.3H25"></path>
                    <path class="st2" fill="none" stroke="#17008C" stroke-width="2.1543" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4.6667" d="M14.2,19l3.6,3.9l7.2-7.7"></path>
                    </svg>
                </div>
                </div>

            </a>
            `
            */
            /*! s: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */
            threeHtml = `
            <style type="text/css">
            .home-header-col:nth-child(2) {top:2px;}
            .benefit-three{display:block;height: auto; width: auto; margin-right:21px; display: flex; align-items: center;}
            .benefit-three .msg{width:74px;margin-right:11px;}
            .benefit-three .msg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#b6f23d;}
            .benefit-three .msg .st1{fill:#17008c;}
            .benefit-three .benefit-three-icon{width: 26px;height:26px;position:relative;}
            .benefit-three .benefit-three-icon [class^="benefit-three-item"]{position:absolute;top:0;right:0;width: 26px;height:26px;}
            .benefit-three .benefit-three-icon .benefit-three-item01{display:block;}
            .benefit-three .benefit-three-icon .benefit-three-item01 .st0{fill:#b6f23d;}
            .benefit-three .benefit-three-icon .benefit-three-item01 .st1{fill:none;stroke:#17008C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            .benefit-three .benefit-three-icon .benefit-three-item01 .st2{fill:none;stroke:#17008C;stroke-width:2.1543;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.6667;}
            [benefit-len="3"] .benefit-two{flex:1; width:auto;margin-right:8px;}
            [benefit-len="3"] .benefit-two .msg{display:none}
            </style>
            <a href="#none" class="benefit-three" data-id="seasenMenuBanner2" role="button">
                <span class="hide-txt">오늘도 출첵</span>
                <div class="msg" aria-hidden="true">
                    <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                            y="0px" viewBox="0 0 73.4 24" style="enable-background:new 0 0 73.4 24;" xml:space="preserve">
                    <style type="text/css">
                        .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C8F03E;}
                        .st1{fill:#140086;}
                    </style>
                    <path class="st0" d="M5.9,0.3h57.6c3.1,0,5.7,2.9,5.7,6.5v10.5c0,3.6-2.5,6.4-5.6,6.4l-57.5,0c-3.1,0-5.7-2.9-5.7-6.5L0.2,6.9
                        C0.2,3.2,2.8,0.3,5.9,0.3z"/>
                    <path class="st0" d="M62.9,12L68,7l5.1,5L68,17L62.9,12z"/>
                    <path class="st1" d="M12.5,9.2c0,0.4,0.1,0.8,0.3,1.2c0.2,0.4,0.5,0.7,0.8,1c0.4,0.3,0.8,0.5,1.4,0.7l-0.7,1.1
                        c-0.6-0.2-1.1-0.4-1.5-0.8c-0.4-0.3-0.8-0.8-1-1.2c-0.2,0.5-0.6,0.9-1,1.3c-0.4,0.4-0.9,0.6-1.5,0.8l-0.7-1.2c0.6-0.2,1-0.4,1.4-0.7
                        s0.7-0.7,0.8-1.1c0.2-0.4,0.3-0.8,0.3-1.3V9.1H8.8V8H11V6.8h1.5V8h2.1v1.2L12.5,9.2L12.5,9.2z M10.5,13.9H12v2h5.8v1.2h-7.3V13.9z
                            M14.3,9.8h1.8V6.8h1.5v7.8h-1.5V11h-1.8V9.8z M24.4,12.7h-5.1V7.6h5.1V12.7z M20.5,13.7H22v2.2h5.8v1.2h-7.3V13.7z M22.9,11.5V8.8
                        h-2.2v2.7H22.9z M25.9,6.8h1.5v3h1.4V11h-1.4v3.4h-1.5V6.8z M38.3,14.7h-1.5v-0.8h-2v-1h2V6.8h1.5V14.7z M29.3,11.4
                        c1.3,0,2.6,0,3.7-0.1c1.1,0,2.2-0.1,3.2-0.2l0.1,1.1c-0.8,0.1-1.7,0.2-2.6,0.3v2h-1.5v1.4h6.5v1.2h-7.9V14h1.5v-1.4
                        c-0.7,0-1.6,0-2.7,0L29.3,11.4z M30,9c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.5-0.5,0.9-0.7c0.4-0.2,0.9-0.2,1.4-0.2c0.5,0,1,0.1,1.4,0.2
                        C34.5,7.5,34.8,7.7,35,8c0.2,0.3,0.3,0.6,0.3,1c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0.2-0.9,0.2-1.4,0.2
                        c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.7-0.4-0.9-0.6C30.2,9.7,30,9.4,30,9z M31.5,9c0,0.3,0.1,0.4,0.3,0.6c0.2,0.1,0.6,0.2,0.9,0.2
                        c0.4,0,0.7-0.1,0.9-0.2C33.9,9.4,34,9.3,34,9c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.2c-0.4,0-0.7,0.1-0.9,0.2
                        C31.6,8.6,31.5,8.8,31.5,9z M50.9,9.1h1.4v1.2h-1.4v2.5h-1.5V6.8h1.5V9.1z M42.8,7.4h1.5v1.3h2.2V7.4h1.5v5h-5.2V7.4z M43.9,13.4h7
                        v1.2h-5.5V16h5.7v1.2h-7.2V13.4z M46.4,11.2V9.9h-2.2v1.4H46.4z M61.8,17.3h-1.5V6.8h1.5V17.3z M52.8,14.3c0.9-0.4,1.7-0.9,2.2-1.4
                        c0.6-0.5,1-1.1,1.4-1.7C56.8,10.5,57,9.8,57,9h-3.6V7.9h5.2c0,1.1-0.2,2.2-0.5,3.1c-0.3,0.9-0.8,1.8-1.6,2.5c-0.7,0.8-1.7,1.4-2.9,2
                        L52.8,14.3z"/>
                    </svg>
                </div>
                <div class="benefit-three-icon" aria-hidden="true">
                    <div class="benefit-three-item01">
                        <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3773_17465)">
                        <path d="M25.673 8.0001V5.1001C25.673 4.0001 24.773 3.1001 23.673 3.1001H16.873V21.1001H23.673C24.773 21.1001 25.673 20.2001 25.673 19.1001V16.2001C23.473 16.1001 21.773 14.3001 21.773 12.1001C21.773 9.9001 23.473 8.1001 25.673 8.0001Z" fill="#C8F03E"/>
                        <path d="M16.7734 3.2998V5.1998" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.7734 8.2998V10.0998" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.7734 13.2002V15.0002" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.7734 18.1001V20.0001" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21.7732 12.1001C21.7732 9.9001 23.4732 8.1001 25.6732 8.0001V5.1001C25.6732 4.0001 24.7732 3.1001 23.6732 3.1001H4.07324C2.97324 3.1001 2.07324 4.0001 2.07324 5.1001V8.0001C4.17324 8.2001 5.87324 9.9001 5.87324 12.1001C5.87324 14.3001 4.17324 16.1001 2.07324 16.2001V19.1001C2.07324 20.2001 2.97324 21.1001 4.07324 21.1001H23.6732C24.7732 21.1001 25.6732 20.2001 25.6732 19.1001V16.2001C23.4732 16.2001 21.7732 14.4001 21.7732 12.1001Z" stroke="#140086" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_3773_17465">
                        <rect width="26.4" height="24" fill="white" transform="translate(0.573242)"/>
                        </clipPath>
                        </defs>
                        </svg>
                    </div>
                </div>

            </a>
            `
            /*! e: FETASK-a11y page 헤더 버튼 접근성 v.1.0.0 */

        }
        if (!$('.benefit-three').length > 0) {
            $benefitArea.attr('benefit-len', 3)
            $benefitArea.prepend(threeHtml);
        }
        $el.data('animateBenefitBtn', false)
    }
    if(!$el[0] || $el.data('animateBenefitBtn')){
        return;
    }
    $el.data('animateBenefitBtn', true)


    const $box = $('.my-header-group .box');
    const $money = $('.my-header-group .money');
    let $msg
    let $seasonIcon
    if ($('.benefit-three').length > 0 ) {
        $seasonIcon = $('.my-header-group .benefit-three-icon');
        $msg = $('.my-header-group .benefit-three .msg');
    } else {
        $seasonIcon = $('.my-header-group .benefit-two-icon');
        $msg = $('.my-header-group .benefit-two .msg');
    }
    // 기존 홈 상단 아이콘 애니메이션
    if (!$seasonIcon.length) { // 기존
        $msg = $('.my-header-group .msg');
        gsap.set($box, {display: 'block', autoAlpha: 1, transformOrigin: 'bottom center'});
        gsap.set($money, {display: 'block', autoAlpha: 0, opacity: 0, x: 20, rotate: '180deg'});
        gsap.set($msg, {display: 'block', autoAlpha: 0, transformOrigin: 'center right', opacity: 0, x: 0, y: -10, scale: 0.5, rotate: '20deg'});
        const _tm2 = gsap.timeline({paused: true});
        const _tm = gsap.timeline({});

        _tm.yoyo(true).repeatDelay(2).repeat(1).timeScale(1).then(() => {
            _tm2.play();
        })

        const _tmBox = gsap.timeline();
        _tmBox.to($box, {duration: 0.5, autoAlpha: 1, scaleY: 1.1, y: -5, ease: 'Power2.easeIn'}, 0);
        _tmBox.to($box, {duration: 0.3, scaleY: 0.9, y: 3});
        _tmBox.to($box, {duration: 0.4, scaleY: 1, y: 0});
        const _tmMoney = gsap.timeline();
        _tmMoney.to($money, {duration: 0.5, autoAlpha: 1, x: 0, opacity: 1, rotate: '0deg', ease: 'Back.easeOut'}, 0.8);
        const _tmMsg = gsap.timeline();
        _tmMsg.to($msg, {duration: 0.5, autoAlpha: 1, x: 0, y: 0, opacity: 1, scale: 1, rotate: '0deg', ease: 'Back.easeOut', onComplete: () => {
            }}, 0.8);
        _tm.add([_tmBox, _tmMoney,_tmMsg], 0);

        const _tmBox2 = gsap.timeline();
        _tmBox2.to($box, {duration: 0.5, autoAlpha: 1, scaleY: 1.1, y: -5, ease: 'Power2.easeIn'}, 0);
        _tmBox2.to($box, {duration: 0.3, scaleY: 0.9, y: 3});
        _tmBox2.to($box, {duration: 0.4, scaleY: 1, y: 0});
        const _tmMoney2 = gsap.timeline();
        _tmMoney2.to($money, {duration: 0.5, autoAlpha: 1, x: 0, opacity: 1, rotate: '0deg', ease: 'Back.easeOut'}, 0.8);
        const _tmMsg2 = gsap.timeline();
        _tmMsg2.to($msg, {display: 'block', autoAlpha: 1, transformOrigin: 'center right', opacity: 1, x: 0, y: 0, scale: 1, rotate: '0'}, 0.8);
        _tm2.add([_tmBox2, _tmMoney2,_tmMsg2], 0);

    } else { // 시즈널  우측 동전 움직임x


        gsap.set($box, {display: 'block', autoAlpha: 1, transformOrigin: 'bottom center'});
        gsap.set($msg, {display: 'block', autoAlpha: 0, transformOrigin: 'center right', opacity: 0, x: 0, y: -10, scale: 0.5, rotate: '20deg'});
        gsap.set($seasonIcon, {display: 'block', autoAlpha: 1, transformOrigin: 'bottom center'});
        gsap.set($money, {display: 'block', autoAlpha: 1, opacity: 1});

        const _tm2 = gsap.timeline({paused: true});
        const _tm = gsap.timeline({});

        _tm.yoyo(true).repeatDelay(2).repeat(1).timeScale(1).then(() => {
            _tm2.play();
        })

        const _tmMsg = gsap.timeline();
        _tmMsg.to($msg, {duration: 0.5, autoAlpha: 1, x: 0, y: 0, opacity: 1, scale: 1, rotate: '0deg', ease: 'Back.easeOut', onComplete: () => {
            }}, 0.8);
        const _tmSeason = gsap.timeline();
        _tmSeason.to($seasonIcon, {duration: 0.5, autoAlpha: 1, scaleY: 1.1, y: -5, ease: 'Power2.easeIn'}, 0);
        _tmSeason.to($seasonIcon, {duration: 0.3, scaleY: 0.9, y: 3});
        _tmSeason.to($seasonIcon, {duration: 0.4, scaleY: 1, y: 0});
        _tm.add([_tmMsg, _tmSeason], 0);


        const _tmMsg2 = gsap.timeline();
        _tmMsg2.to($msg, {display: 'block', autoAlpha: 1, transformOrigin: 'center right', opacity: 1, x: 0, y: 0, scale: 1, rotate: '0'}, 0.8);
        const _tmSeason2 = gsap.timeline();
        _tmSeason2.to($seasonIcon, {duration: 0.5, autoAlpha: 1, scaleY: 1.1, y: -5, ease: 'Power2.easeIn'}, 0);
        _tmSeason2.to($seasonIcon, {duration: 0.3, scaleY: 0.9, y: 3});
        _tmSeason2.to($seasonIcon, {duration: 0.4, scaleY: 1, y: 0});
        _tm2.add([_tmMsg2, _tmSeason2], 0);
    }
}
function animateBenefitBtnRemove() {
    $('[data-benefit-area]').find('*').remove()
}

function christmasEffect(active = true){
    let snowFlakes_count = 24;

    function spawn_snow(snow_density = 30) {
        snow_density -= 1;

        let x = snow_density;

        setInterval(function(){
          if (x != 0) {
            x -= 1;
            let board = document.createElement('div');
            board.className = "snowflake";
            document.getElementById("snow").appendChild(board);
          }
        }, 800);

        // for (let x = 0; x < snow_density; x++){
        //     let board = document.createElement('div');
        //     board.className = "snowflake";
        //     document.getElementById("snow").appendChild(board);
        // }
    }

    function add_css(rule) {
        let css = document.createElement('style');
        css.type = 'text/css';
        css.classList.add('snowStyle');
        css.appendChild(document.createTextNode(rule));
        document.getElementsByTagName('head')[0].appendChild(css)
    }

    function random_int(value = 100) {
        return Math.floor(Math.random() * value) + 1;
    }

    function random_range(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);

        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function spawnSnowCss(snow_density = 30) {
        let snowflake_name = "snowflake";
        let rule = '';

        for (let i = 1; i < snow_density; i++) {
            let random_x = Math.random() * 100 //vw
            let random_offset = random_range(-100000, 100000) * 0.0001; //vw
            let random_x_end = random_x + random_offset;
            let random_x_end_yoyo = random_x + (random_offset / 2);
            let random_yoyo_time = random_range(30000, 80000) / 100000;
            let fall_duration = random_range(30, 40, 60, 80) * 1 //s
            let fall_delay = random_int(40) * -1; //s
            let opacity_ = Math.random();
            let opacityAfter = opacity_ < 0.9 ? (0.7 - opacity_) + opacity_ : opacity_;
            let rotationX = random_range(0, 360);
            let rotationY = random_range(-90, 90);
            let rotationXDef = rotationX > 180 ? (rotationX - 100) : (rotationX + 100);
            rule += `
                .${snowflake_name}:nth-child(${i}){
                    opacity: ${opacityAfter};
                    transform: translate(${random_x - (50 - random_x_end_yoyo)}vw, -10px);
                    animation: fall-${i} ${fall_duration}s ${fall_delay}s linear infinite;
                }
                @keyframes fall-${i} {
                    ${random_yoyo_time*100}% {
                        transform: translate(${random_x_end}vw, ${random_yoyo_time*100}vh) rotate(${rotationY}deg);
                    }

                    to {
                        transform: translate(${random_x_end_yoyo}vw, 100vh) rotate(${rotationY * -1}deg);
                    }
                }
            `
        }
        add_css(rule)
    }

    $(function(){
        if (active === true) {
            if ($('#snow').length == 0) {
                $('.main-tab-container').closest('#content-mmk').css('overflow', 'hidden').prepend('<div id="snow"></div>')
                spawnSnowCss(snowFlakes_count);
                spawn_snow(snowFlakes_count)
            }
        } else {
            if ($('#snow').length > 0) {
                $('#snow').remove();
                $('.snowStyle').remove();
            }
        }
    })
}

// 미가입상품 추가 진입점
export function mainRandomProdShow(item){
    if ($('.flip-conts').length < 0) {
        return false
    }
    if ($('.flip-conts .swiper-wrapper').find('li').length > 0) {
        $('.flip-conts .swiper-wrapper').find('li').remove();
    }

    const shuffle = () => (Math.random() - 0.5)
    var itemArr = item.sort(shuffle);
    if (item.length % 2 != 0 && item.length > 2) {
        itemArr.push(itemArr[1])
    }
    for (var i =0; i < itemArr.length; i++) {
        $('.flip-conts .swiper-wrapper').append(`<li class="swiper-slide">
        <a href="${itemArr[i].link}">
          <div class="home-card-layout-group join-gate">
            <div class="card-img-figure">
              <i class="ico-home-plus" aria-hidden="true"></i>
            </div>
            <div class="card-text-box">${itemArr[i].title}</div>
          </div>
        </a>
      </li>`)
    }
    $('.flip-conts').data('ui').update()
}
export function mainViewPortSmallCheck(){
    console.log('viewport check')
    $(window).on('load', function(){
        if ($(window).width() < 300) {
            $('html').addClass('viewport-s')
        }
    })
    $(window).on('resize', function(){
        if ($(window).width() < 300) {
            if (!$('html').hasClass('viewport-s')) {
                $('html').addClass('viewport-s')
            }
        } else {
            if ($('html').hasClass('viewport-s')) {
                $('html').removeClass('viewport-s')
            }
        }
    })
}

// tobe:::: main.ui.js분리건
export function mainUI() {
    mainTabControl();
    closeComponent();
    //animateBenefitBtn({secondBtn:'defalut',thirdBtn:'season'}); //  // 240221 : 개발에서 실행방식으로 변경
    mainViewPortSmallCheck()
    let bodyHidden;
    if ($('.notchBg').length < 1){
        let bodyCss = document.createElement('style');
        bodyCss.type = 'text/css';
        bodyCss.classList.add('notchBg')
        bodyHidden = 'body {overflow:hidden}'

        bodyCss.appendChild(document.createTextNode(bodyHidden));
        document.getElementsByTagName('head')[0].appendChild(bodyCss)
    }
}

window.frontUI = {
    ...window.frontUI,

    mainRevealAnimationInit,
    mainRemitComponentClose,
    mainTimelineMoreView,
    mainTimelinePullToRefresh,
    mainBenefitSpaceMargin,
    mainTalkWelcome,
    mainUI,
    mainRandomProdShow,
    mainFixedTab,
    mainViewPortSmallCheck,

    main: {
        mainRevealAnimationInit: mainRevealAnimationInit,
        mainRemitComponentClose: mainRemitComponentClose,
        mainRandomProdShow: mainRandomProdShow,
        mainTimelineMoreView: mainTimelineMoreView,
        mainTimelinePullToRefresh: mainTimelinePullToRefresh,
        mainBenefitSpaceMargin: mainBenefitSpaceMargin,
        mainTalkWelcome: mainTalkWelcome,
        christmasEffect: christmasEffect,
        animateBenefitBtn: animateBenefitBtn,
        animateBenefitBtnRemove: animateBenefitBtnRemove,
        mainFixedTab:mainFixedTab,
    },
}

